import React, { useRef, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";

import "../styles/PrivacyPolicy.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import { Link } from "react-router-dom";
import "../styles/Aerospace.css";
import ModalFunction from "./Modal";
const census = "/img/census.png";

const logo = "/img/1.png";
const kpi = "/img/KPI-DASH 2.png";
const AboutUsImage = "/img/aboutus1.avif";
const sourcelogo1 = "/img/unemployment-logo.png";
const sourcelogo2 = "/img/utah-job-logo.png";
const kem = "/img/kem.png";

export default function PrivacyPolicy() {
  const [modalShow, setModalShow] = React.useState(false);
  const iconData = [
    { icon: "fa-fighter-jet", title: "Aerospace and Defense" },
    { icon: "fa-seedling", title: "Agriculture, Food, and Natural Resources" },
    { icon: "fa-briefcase", title: "Business, Finance, and Marketing" },
    { icon: "fa-cogs", title: "Engineering and Technology" },
    { icon: "fa-hands-helping", title: "Human Services" },
    { icon: "fa-truck", title: "Transportation, Distribution, and Logistics" },
    { icon: "fa-building", title: "Architecture and Construction" },
    { icon: "fa-laptop-code", title: "Computer Science and IT" },
    { icon: "fa-heartbeat", title: "Health Science" },
    {
      icon: "fa-balance-scale",
      title: "Law, Public Safety, Corrections, and Security",
    },
    {
      icon: "fa-paint-brush",
      title: "Arts, Audio/Visual Technology, and Communication",
    },
    { icon: "fa-graduation-cap", title: "Education and Training" },
    { icon: "fa-concierge-bell", title: "Hospitality and Tourism" },
    { icon: "fa-industry", title: "Manufacturing" },
  ];

  const navbarRef = useRef(null);

  // Close the navbar on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        const navbarCollapse =
          navbarRef.current.querySelector(".navbar-collapse");
        if (navbarCollapse) {
          navbarCollapse.classList.remove("show"); // Close the navbar
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <LandingSection
        data={{ imageName: "copyright.webp", title: "Privacy Policy" }}
      />

      {/* Privacy Policy Section */}
      <div className="mt-[3rem] px-4 sm:px-0 privacy-policy-content">
        <h2
          style={{
            fontSize: "40px",
            textAlign: "center",
            marginTop: "60px",
            color: "#0b3378",
          }}
        >
          Privacy Policy
        </h2>
        <p
          style={{
            fontSize: "24px",
            marginTop: "30px",
            marginBottom: "60px",
            color: "#0b3378",
          }}
        >
          At{" "}
          <strong data-start="284" data-end="300">
            UTahData.org
          </strong>
          , we are committed to transparency and respecting your privacy. This
          Privacy Policy explains how we handle information when you use our
          website.
        </p>

        <ul className="privacy-policy-list">
          <li>
            <strong>1. What We Do</strong>{" "}
            <p>
              UTahData.org is a public data reporting portal. We do{" "}
              <strong data-start="518" data-end="525">
                not
              </strong>{" "}
              collect personal data from users, nor do we provide user accounts,
              subscriptions, or contact forms that gather personally
              identifiable information (PII).
            </p>
          </li>
          <li>
            <strong>2. Analytics and Cookies</strong>{" "}
            <p>
              We use{" "}
              <strong data-start="717" data-end="737">
                Google Analytics
              </strong>{" "}
              to understand how users interact with our site and to improve the
              quality of our content. This tool may collect anonymous
              information such as:{" "}
            </p>
            <p className="mt-3 ml-4">
              <b>IP address (anonymized by Google)</b>
            </p>
            <p className="ml-4">
              <b>Browser type and device</b>
            </p>
            <p className="ml-4">
              <b>Pages visited and time spent</b>
            </p>
            <p className="ml-4">
              <b>Geographic region (not exact location)</b>
            </p>
            <p>
              Google Analytics uses cookies to collect this data. You can choose
              to disable cookies in your browser settings or opt out using tools
              provided by Google.
            </p>
            <p data-start="1171" data-end="1283">
              <strong data-start="1171" data-end="1186">
                Learn more:
              </strong>{" "}
              <a
                class="cursor-pointer"
                href="https://policies.google.com/technologies/partner-sites"
                target="_new"
                rel="noopener"
                data-start="1187"
                data-end="1283"
              >
                How Google uses information from sites
              </a>
            </p>
          </li>
          <li>
            <strong>3. External Links</strong>{" "}
            <p>
              Complex information is transformed into engaging,
              easy-to-understand visualizations for everyone.
            </p>
          </li>
          <li>
            <strong>4. Changes to This Policy</strong>{" "}
            <p>
              We may update this policy occasionally to reflect changes in
              technology or legal requirements. Any updates will be posted on
              this page with a new effective date.
            </p>
          </li>
        </ul>
      </div>
      {/* Footer */}
      <Footer />
    </>
  );
}
